import React from 'react';

import { CampaignType } from 'src/actions/campaigns/campaignsResource';
import RecipientCollections from 'src/presentation/components/pages/proactiveCommunications/components/shared/RecipientCollections';
import AddSmsRecipientsForm from './AddSmsRecipientsForm';
import SmsCampaignContentDetails from './SmsCampaignContentDetails';

const SmsRecipientCollections = ({ root }) => (
  <RecipientCollections
    addRecipientFormComponent={AddSmsRecipientsForm}
    backButtonLabel="Proactive SMS"
    campaignContentDetailsComponent={SmsCampaignContentDetails}
    campaignType={CampaignType.SMS}
    root={root}
  />
);

export default SmsRecipientCollections;
